
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/day-of-week/[[...pathParams]]",
      function () {
        return require("private-next-pages/landing/day-of-week/[[...pathParams]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/day-of-week/[[...pathParams]]"])
      });
    }
  